import { createFileRoute } from '@tanstack/react-router';
import { OAuthCallbackPage } from '~/components/Credentials/OAuth1Token/OAuth1CallbackURL.tsx';
import { z } from 'zod';

const searchSchema = z.object({
  state: z.string().min(1),
});

export const Route = createFileRoute('/callback/oauth1')({
  component: RouteComponent,
  validateSearch: searchSchema,
  search: {
    middlewares: [
      ({ search, next }) => {
        const result = next(search);

        return {
          ...result,
          state: search.state,
        };
      },
    ],
  },
});

function RouteComponent() {
  const params = Route.useSearch();

  return <OAuthCallbackPage state={params.state} />;
}
